/** Who steers: Iris leads with her chips in the top bar, or the maker directs and she waits. */
export type IrisMode = "guided" | "independent";

const MODE_KEY = "caprica.iris.mode";
const listeners = new Set<() => void>();

/** Iris leads unless the maker chose to direct themselves. */
export function irisMode(): IrisMode {
  try {
    return window.localStorage.getItem(MODE_KEY) === "independent" ? "independent" : "guided";
  } catch {
    return "guided";
  }
}

export function setIrisMode(mode: IrisMode): void {
  try {
    window.localStorage.setItem(MODE_KEY, mode);
  } catch {
    /* a private window keeps the default */
  }
  for (const listener of listeners) listener();
}

export function subscribeCompanion(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const askListeners = new Set<(text: string) => void>();

/** Put a question in Iris's own conversation from anywhere on the page (her panel opens with it). */
export function requestIrisAsk(text: string): void {
  for (const listener of askListeners) listener(text);
}

export function onIrisAsk(listener: (text: string) => void): () => void {
  askListeners.add(listener);
  return () => askListeners.delete(listener);
}
